import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function swiperPostsCarousel() {
    const selector = ".swiper-posts-carousel";
    if (!document.querySelector(selector)) return;

    new Swiper(selector, {
        modules: [Navigation, Pagination],
        slidesPerView: 1.1,
        spaceBetween: 16,
        centeredSlides: false,
        loop: true,
        speed: 600,

        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

        breakpoints: {
            576: {
                slidesPerView: 1.5,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 24,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 30,
            }
        }
    });
}
